import { bool, node, number } from "prop-types";
import { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import useWidth from "Utilities/Hooks/useWidth";
import dynOpactity from "Utilities/interpolations/dynOpactity";
import dynWidth from "Utilities/interpolations/dynWidth";

/**
 * A simple reveal effect that includes layout changes.
 * @param {object} param0
 */
const FnrSimpleReveal = ({ show, delayIn, children }) => {
  const contentRef = useRef();
  const width = useWidth(contentRef);

  const [showTimeout, setShowTimeout] = useState(!delayIn);
  const timeoutRef = useRef();

  useEffect(() => {
    if (show) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setShowTimeout(true), delayIn);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [delayIn, show]);

  useEffect(() => {
    if (!show && delayIn) setShowTimeout(false);
  }, [show, delayIn]);

  return (
    <Container
      $width={show && showTimeout ? width : 0}
      $opacity={show && showTimeout ? 1 : 0}
    >
      <Content ref={contentRef}>{children}</Content>
    </Container>
  );
};

const Container = styled.div`
  ${dynWidth}
  ${dynOpactity}
  overflow: clip;
  transition: width 200ms, opacity 200ms;
`;

const Content = styled.div`
  min-width: fit-content;
`;

FnrSimpleReveal.propTypes = {
  children: node.isRequired,
  show: bool,
  delayIn: number,
};

export default FnrSimpleReveal;
